/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Beweegthema_Honkloopspelen2Inputs */

const nl_enums_beweegthema_honkloopspelen2 = /** @type {(inputs: Enums_Beweegthema_Honkloopspelen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Honkloopspelen`)
};

/**

* @param {Enums_Beweegthema_Honkloopspelen2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_beweegthema_honkloopspelen2 = /** @type {((inputs?: Enums_Beweegthema_Honkloopspelen2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Beweegthema_Honkloopspelen2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_beweegthema_honkloopspelen2(inputs)
});
export { enums_beweegthema_honkloopspelen2 as "enums.Beweegthema.Honkloopspelen" }